import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { OverOns } from './pages/OverOns';
import { Collectie } from './pages/Collectie';
import { Bronnen } from './pages/Bronnen';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3f8ndlgc3j77i">
      <Routes data-id="element-1" data-mp="2rknmugesbgsx">
        <Route element={<Layout data-id="element-3" data-mp="2rlyoa9krccgv" />} data-id="element-2" data-mp="2rk45p1wykwfy">
          <Route path="/" element={<Home data-id="element-5" data-mp="2riklj086m18w" />} data-id="element-4" data-mp="2rl6v15emuqtr" />
          <Route path="/over-ons" element={<OverOns data-id="element-7" data-mp="2mn5bkjdaophr" />} data-id="element-6" data-mp="2mm2j470bqezq" />
          <Route path="/collectie" element={<Collectie data-id="element-9" data-mp="31agnimde2bie" />} data-id="element-8" data-mp="2mnnefyugq1yn" />
          <Route path="/bronnen" element={<Bronnen data-id="element-11" data-mp="31c1gw8nyvoeo" />} data-id="element-10" data-mp="31bs2licab5ot" />
          <Route path="/contact" element={<Contact data-id="element-13" data-mp="2wjqi594yq8np" />} data-id="element-12" data-mp="31cjjro54x0vk" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-15" data-mp="2whx9xpepbgdl" />} data-id="element-14" data-mp="2wj8f9tnsow6t" />
        </Route>
      </Routes>
    </BrowserRouter>;
}